import { FaqHighlightComponent } from './faq-search/faq-highlight/faq-highlight.component';

import { NgModule } from '@angular/core';
import { FaqComponent } from './faq.component';
import { FaqCategoryComponent } from './faq-category/faq-category.component';
import { FaqSummaryComponent } from './faq-summary/faq-summary.component';
import { StaticContentService } from '../shared/services/static-content.service';
import { RouterModule } from '@angular/router';
import { faqRoute } from './faq.route';
import { FaqSearchComponent } from './faq-search/faq-search.component';
import { HighlightSearchPipe } from './faq-search/highlight-search.pipe';
import { TelerecourspnrSharedModule } from '../shared';

@NgModule({
  imports: [
    TelerecourspnrSharedModule,
    RouterModule.forRoot([faqRoute], { useHash: true }),
  ],
  declarations: [
    FaqComponent,
    FaqSummaryComponent,
    FaqCategoryComponent,
    FaqSearchComponent,
    FaqHighlightComponent,
    HighlightSearchPipe
  ],
  providers: [
    StaticContentService,
    HighlightSearchPipe
  ]
})
export class TelerecourspnrFaqModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/faq/faq.module.ts